// extracted by mini-css-extract-plugin
export default {"container":"oM-z","topReviewHeading":"pM-z","criticalReview":"qM-z","favorableReview":"rM-z","vsSeparator":"sM-z"};